import { suppressDataDetectors } from '../../design-system';

type Props = {
  title: string;
};

/** The card's name under it on sleek's winner and Vault card page. */
export function SleekCardTitle({ title }: Props) {
  return (
    <h2
      data-co-component="WinnerStepTitle"
      className="mx-auto mb-6 max-w-[300px] line-clamp-2 text-center text-[16px] font-medium leading-[19px] [word-break:break-word]"
      style={{ color: 'var(--co-WinnerStepTitle-color, #FFFFFF)' }}
    >
      {suppressDataDetectors(title)}
    </h2>
  );
}
